import MoneyIcon from "@material-ui/icons/Money";
import ContributionAmountList from "./ContributionAmountList";

export default {
  list: ContributionAmountList,
  icon: MoneyIcon,
};
